module.exports = __webpack_public_path__ + "static/media/suntrust.00f8130b.svg";